import {
  CsvFormat,
  ISODateString,
  SortDirection,
} from '@mesa-labs/mesa-api/dist/types';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export const PaginationLimits = [
  { key: '10', value: 10 },
  { key: '25', value: 25 },
  { key: '50', value: 50 },
  { key: '100', value: 100 },
];

export type CollectionsState = {
  page: number;
  limit: { key: string; value: number };
  total?: number;
  searchTerm?: string;
  startDate?: ISODateString;
  endDate?: ISODateString;
  displayEndDate?: ISODateString;
  sortField?: string;
  sortDirection: SortDirection;
  exportFormat: CsvFormat;
};

const initialState: CollectionsState = {
  page: 1,
  limit: PaginationLimits[0],
  total: undefined,
  searchTerm: undefined,
  startDate: undefined,
  endDate: undefined,
  displayEndDate: undefined,
  sortField: undefined,
  sortDirection: SortDirection.DESCENDING,
  exportFormat: CsvFormat.MESA_CSV_FORMAT,
};

const collectionsSlice = createSlice({
  name: 'collections',
  initialState,
  reducers: {
    updatePage(state: CollectionsState, action: PayloadAction<number>) {
      state.page = action.payload;
    },
    updateLimit(state: CollectionsState, action: PayloadAction<{ key: string; value: number }>) {
      state.limit = action.payload;
    },
    updateTotal(state: CollectionsState, action: PayloadAction<number>) {
      state.total = action.payload;
    },
    updateStartDate(state: CollectionsState, action: PayloadAction<ISODateString | undefined>) {
      state.startDate = action.payload;
    },
    updateEndDate(state: CollectionsState, action: PayloadAction<ISODateString | undefined>) {
      state.endDate = action.payload;
    },
    updateSearchTerm(state: CollectionsState, action: PayloadAction<string>) {
      state.searchTerm = action.payload;
    },
    updateSortField(state: CollectionsState, action: PayloadAction<string>) {
      state.sortField = action.payload;
    },
    updateSortDirection(state: CollectionsState, action: PayloadAction<SortDirection>) {
      state.sortDirection = action.payload;
    },
    updateExportFormat(state: CollectionsState, action: PayloadAction<CsvFormat>) {
      state.exportFormat = action.payload;
    },
  },
});

export const {
  updatePage,
  updateLimit,
  updateTotal,
  updateStartDate,
  updateEndDate,
  updateSearchTerm,
  updateSortField,
  updateSortDirection,
  updateExportFormat,
} = collectionsSlice.actions;
export default collectionsSlice.reducer;
